module.exports = __webpack_public_path__ + "static/media/box2-0.c6c73f70.bmp";